import React from 'react';
import { IProps, IState } from 'components/SliderAdvanced/types';
import swiperService from 'plugins/swiperService';
import Item from 'components/SliderAdvanced/Item';

class SliderAdvanced extends React.Component<IProps, IState> {
  static Item = Item as typeof Item;
  private infoBlockContent: any[] = [];
  private sliderInstance: any;

  static defaultProps = {
    infoBlock: true,
    moreBlock: true,
    pagination: true
  };

  readonly state: IState = {
    activeIndex: 0
  }

  constructor (props: IProps) {
    super(props);
    this.infoBlockContent = this.getInfoBlockContent();
  }

  componentDidMount () {
    this.setUpSlider();
    this.getSliderActiveIndex();
  }

  componentWillUnmount () {
    this.destroySlider();
  }

  // 設置 Slider
  setUpSlider = () => {
    const { name } = this.props;
    const container = `.${name}`;
    const options = {
      slidesPerView: 1,
      speed: 750,
      loop: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 8000
      },
      navigation: {
        nextEl: `#${name}-next-btn`,
        prevEl: `#${name}-prev-btn`
      },
      pagination: {
        el: '.slider__pagination',
        clickable: true,
        bulletClass: 'slider__pagination-bullet',
        bulletActiveClass: 'slider__pagination-bullet--active',
        renderBullet: (index: number, className: string) => {
          return (
            '<li class="' + className + '">' +
              '<div class="slider__pagination-bullet-decoration" />' +
            '</li>'
          );
        }
      }
    };
    this.sliderInstance = swiperService.instance(container, options);
  }

  // 銷毀 Slider
  destroySlider = () => {
    this.sliderInstance.destroy(true, true);
  }

  // 取得 Slider Active Index
  getSliderActiveIndex = () => {
    this.sliderInstance.on('slideChange', () => {
      this.setState(state => ({ ...state, activeIndex: this.sliderInstance.realIndex }));
    });
  }

  // 取得 Info Block 內容
  getInfoBlockContent = () => {
    const infoBlockContent: any[] = [];

    React.Children.forEach(this.props.children, (element) => {
      if (React.isValidElement(element)) {
        const { title, desc, activityUrl } = element.props;
        const content = (title && desc && activityUrl) ? { title, desc, activityUrl } : null;
        infoBlockContent.push(content);
      }
    });

    return infoBlockContent;
  }

  // 渲染 Info Block
  renderInfoBlockElement = () => {
    const { infoBlock } = this.props;
    const { activeIndex } = this.state;

    return (infoBlock && this.infoBlockContent[activeIndex]) && (
      <div className="slider-advanced__info-block">
        <div className="slider-advanced__info-text">
          <span>{this.infoBlockContent[activeIndex].title}</span>
          <p>{this.infoBlockContent[activeIndex].desc}</p>
        </div>
        <a href={this.infoBlockContent[activeIndex].activityUrl} target="_blank" rel="noopener noreferrer" className="slider-advanced__info-link">{}</a>
      </div>
    );
  }

  // 渲染 More Block
  renderMoreBlockElement = () => {
    const { moreBlock, moreBlockText, moreBlockLink } = this.props;

    return (moreBlock && moreBlockText && moreBlockLink) && (
      <div className="slider-advanced__more-block">
        <a href={moreBlockLink} target="_blank" rel="noopener noreferrer">{moreBlockText}</a>
      </div>
    );
  }

  // 渲染 Pagination
  renderPaginationElement = () => {
    const { pagination } = this.props;

    return pagination && (
      <ul className="slider__pagination" />
    );
  }

  render () {
    const { name, children } = this.props;
    return (
      <div className="slider-advanced">
        <div className="slider-advanced__container">
          <div className={`swiper-container ${name}`}>
            <div className="swiper-wrapper">
              {children}
            </div>
          </div>
          <button type="button" id={`${name}-prev-btn`} className="slider__prev-btn" />
          <button type="button" id={`${name}-next-btn`} className="slider__next-btn" />
        </div>
        <div className="slider-advanced__patches">
          <div className="slider-advanced__patches-col">
            {this.renderInfoBlockElement()}
          </div>
          <div className="slider-advanced__patches-col">
            {this.renderMoreBlockElement()}
            {this.renderPaginationElement()}
          </div>
        </div>
      </div>
    );
  }
};

export default SliderAdvanced;
